import React from 'react';

function Projects() {
    const projects = [
        {
            title: "AMAFA Agriculture",
            description: "Empowering Ugandan farmers with real-time data visualisations and agricultural intelligence.",
            technologies: ["Flutter", "Firebase", "Node.js"],
            icon: "bi-flower3",
            link: "#"
        },
        {
            title: "Quick Pickup",
            description: "A high-performance ride-hailing ecosystem built for speed and enterprise-grade reliability.",
            technologies: ["React Native", "MySQL", "Maps API"],
            icon: "bi-lightning-charge-fill",
            link: "#"
        },
        {
            title: "School Admin",
            description: "Streamlining student administration and resource management for modern driving schools.",
            technologies: ["PHP", "Tailwind", "MySQL"],
            icon: "bi-journal-check",
            link: "#"
        },
        {
            title: "Asset Track",
            description: "End-to-end IT asset auditing and lifecycle management for large-scale infrastructures.",
            technologies: ["React", "Python", "SQL"],
            icon: "bi-safe2-fill",
            link: "#"
        }
    ];

    return (
        <section id="projects" className="py-32 bg-black relative">
            <div className="max-w-7xl mx-auto px-6 lg:px-12">
                <div className="flex flex-col items-center mb-24 animate-fade-in-up">
                    <h2 className="text-green-500 font-black tracking-widest text-sm uppercase mb-4">Portfolio</h2>
                    <h3 className="text-6xl md:text-8xl font-black text-white text-center leading-none tracking-tighter uppercase mb-8">Selected <br /><span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-500 to-white">Works.</span></h3>
                    <div className="w-20 h-1 bg-green-500 rounded-full"></div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
                    {projects.map((project, index) => (
                        <div
                            key={index}
                            className={`group relative glass-card rounded-[3rem] overflow-hidden transition-all duration-700 hover:-translate-y-4 hover:border-green-500/50 ${index % 2 !== 0 ? 'md:mt-24' : ''}`}
                        >
                            <div className="h-[400px] bg-neutral-900 flex items-center justify-center relative overflow-hidden">
                                {/* Geometric Graphics */}
                                <div className="absolute inset-0 opacity-10 flex items-center justify-center pointer-events-none">
                                    <div className="w-[500px] h-[500px] border border-white rounded-full animate-spin-slow"></div>
                                    <div className="w-full h-full bg-[radial-gradient(circle_at_center,rgba(71,232,2,0.1)_0%,transparent_70%)]"></div>
                                </div>

                                <i className={`bi ${project.icon} text-9xl text-neutral-800 group-hover:text-green-500/20 group-hover:scale-125 transition-all duration-700`}></i>

                                <div className="absolute inset-0 bg-black/80 backdrop-blur-md opacity-0 group-hover:opacity-100 transition-all duration-500 flex flex-col justify-center items-center p-12 text-center scale-95 group-hover:scale-100">
                                    <h4 className="text-3xl font-black text-green-500 uppercase mb-4 tracking-tighter">{project.title}</h4>
                                    <p className="text-gray-300 text-lg font-medium leading-relaxed mb-8">
                                        {project.description}
                                    </p>
                                    <a href={project.link} className="btn-primary flex items-center gap-3">
                                        Case Study <i className="bi bi-arrow-right"></i>
                                    </a>
                                </div>
                            </div>

                            <div className="p-10 flex flex-col items-start gap-6 border-t border-white/5">
                                <div className="flex justify-between items-center w-full">
                                    <h3 className="text-2xl font-black text-white uppercase tracking-tighter">
                                        {project.title}
                                    </h3>
                                    <div className="flex gap-2">
                                        {project.technologies.slice(0, 2).map((tech, techIndex) => (
                                            <span
                                                key={techIndex}
                                                className="px-3 py-1 bg-white/5 border border-white/10 rounded-lg text-[10px] font-black text-gray-500 uppercase tracking-widest"
                                            >
                                                {tech}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Projects;
